"use client"

import { useState, useRef, useEffect } from "react"
import { TextField, IconButton, Box } from "@mui/material"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import { format } from "date-fns"
import { Calendar } from "./NewCalendar"

export function CustomDatePicker({ onChange, value, label, ...props }) {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : null)
  const containerRef = useRef(null)

  useEffect(() => {
    if (value) {
      setSelectedDate(new Date(value))
    }
  }, [value])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const handleDateSelect = (date) => {
    const formattedDate = format(date, "yyyy-MM-dd")
    setSelectedDate(date)
    setIsOpen(false)
    if (onChange) {
      onChange({ target: { value: formattedDate } })
    }
  }

  const toggleCalendar = () => {
    setIsOpen(!isOpen)
  }

  return (
    <Box ref={containerRef} sx={{ position: "relative" }}>
      <TextField
        {...props}
        label={label}
        value={selectedDate ? format(selectedDate, "dd-MM-yyyy") : ""}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton onClick={toggleCalendar} edge="end" size="small">
              <CalendarTodayIcon fontSize="small" />
            </IconButton>
          ),
        }}
        onClick={toggleCalendar}
        sx={{
          "& .MuiInputBase-input": {
            cursor: "pointer",
          },
        }}
      />
      
      {isOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#02111B",
              borderRadius: 1,
              boxShadow: 24,
              p: 2,
              width: 350,
              position: "relative",
            }}
          >
            <Box
              component="button"
              onClick={() => setIsOpen(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "text.secondary",
                "&:hover": {
                  color: "text.primary",
                },
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "1rem",
              }}
            >
              ✖
            </Box>
            <Calendar selectedDate={selectedDate} onDateSelect={handleDateSelect} />
          </Box>
        </Box>
      )}
    </Box>
  )
}